/**
 * Class that automaticly switched the source of the video based on the current window size
 * How to use: put a data-src attribute on the video element itself for the default video to show,
 * put a data-src attribute on all the source elements (can't use normal src because then it will try to use them automaticly),
 * put a data-mw attribute on all the source elements that represents the max-width to show that source in pixels
 */
class DynamicVideoSource {
    constructor(selector) {
        const video = document.querySelector(selector);
        this.options = { 
            selector, 
            breakpoints: { default: { src: video.getAttribute('data-src') } } 
        };

        // get a list of video switching points and links to the videos themselves 
        video.querySelectorAll('[data-src]').forEach(element => this.options.breakpoints[element.getAttribute('data-mw')] = { src: element.getAttribute('data-src') });
        video.innerHTML = ''; // Clean up so there is nothing superfluous 
        
        // Run the handler and track the change in screen width
        this.responseVideo(this.options);
        this.resizer();
    }

    /** Function runs on resize  */
    resizer() {
        window.addEventListener("resize", () => this.responseVideo(this.options));
    }

    /** 
     * Change src value of video link to fit screen width 
     * @param {Object} options object with options 
     */
    responseVideo(options) {
        const {selector, breakpoints} = options; // get options
        let video = document.querySelector(selector);
        const widthNow = video.getAttribute('data-width-now') || null;
        let breakPoints = Object.keys(breakpoints).map(Number).filter(bp => !Number.isNaN(bp));
        breakPoints.sort(function(a, b) {
          return a - b;
        });
        let maxBreakpoint;
        const clientWidth = document.body.clientWidth;
        //If the biggest breakpoint is not bigger than current screen size then video should be the default one
        for (let i = 0; i < breakPoints.length; i++) {
          const bp = breakPoints[i];
          if (bp >= clientWidth) {
            maxBreakpoint = bp;
            break;
          }
        }
        let nowBreakpoint = 'default'; // Choose either the maximum value, if not, then the default
        if (maxBreakpoint && maxBreakpoint != -Infinity) nowBreakpoint = maxBreakpoint;
        if(widthNow && widthNow == nowBreakpoint) return; // Check if the video needs to be changed 

        video.setAttribute('data-width-now', nowBreakpoint);
        video.src = breakpoints[nowBreakpoint].src;
    }
}